import { Component, OnInit } from "@angular/core";
import {
    NgbModalConfig,
    NgbModal,
    NgbModalOptions,
    ModalDismissReasons,
} from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router, NavigationStart } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import {
    FormControl,
    FormsModule,
    Validators,
    FormGroup,
} from "@angular/forms";
import { moveItemInArray } from "@angular/cdk/drag-drop";

import { InvoiceService } from "./../../../_services/invoice.service";
import { PosService } from "src/app/_services/posService";
import { DirtyCheckComponent } from "src/app/_models/dirty-check.component";

@Component({
    selector: "app-upload-preview",
    templateUrl: "./upload-preview.component.html",
    styleUrls: ["./upload-preview.component.scss"],
})
export class UploadPreviewComponent implements OnInit, DirtyCheckComponent {
    invoiceDetails: any;
    invoiceType: any;
    closeResult: string = "";
    modalOptions: NgbModalOptions;
    loading: boolean = false;
    invoiceSaved: boolean = false;
    uploadInvoice: boolean = false;
    uploadSuccessful: boolean = false;
    saving: boolean = false;
    displayName: any;
    hasError = false;
    pdfSrc: any;
    fileSizeError = false;
    fileTypeError = false;
    totalSizeError = false;
    typeError = false;
    sizeError = false;
    supportingDocuments: any[] = [];
    invoiceFile: any;
    invoiceDataToSave: any;
    isInvoiceChange: boolean = false;
    isUpdatedData: boolean = false;
    invoiceChanged: boolean = false;
    responseData: any;
    isCondensed: boolean = false;
    currentLayout = {
        isCondensed: true,
    };
    barcodeNo: any;
    poNumber: any;
    eInvoice = false;
    servItems: any;
    eLoaderMsg = "";
    formSubmitted = false;
    previousUrl: any;
    files: File[];
    canSubmitForm = false;
    allDeleted = false;
    supportingDocsAdded = false;
    isSubmittingInvoice: boolean = false;

    extractedInvoice = new FormGroup({
        invoiceType: new FormControl("e-invoice"),
        file: new FormControl(null),
        supportingFiles: new FormControl([]),
        fileSource: new FormControl(""),
        documentSource: new FormControl(""),
        terms_agreed: new FormControl(false),
    });

    constructor(
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute,
        private http: HttpClient,
        private invoiceService: InvoiceService,
        private posService: PosService
    ) {
        this.modalOptions = {
            backdrop: "static",
            backdropClass: "customBackdrop",
            scrollable: true,
        };

        this.router.events.subscribe((val) => {
            if (val instanceof NavigationStart) {
                this.previousUrl = val.url;
            }
        });
    }

    toggleSidebar() {
        this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
        document.body.setAttribute(
            "data-sidebar-size",
            this.currentLayout.isCondensed ? "condensed" : "default"
        );
    }

    canDeactivate() {
        if (!this.formSubmitted) {
            this.loading = true;
            return false;
        } else {
            return true;
        }
    }

    exitForm() {
        this.loading = false;
        this.formSubmitted = true;
        this.router.navigateByUrl(this.previousUrl);
    }

    cancelExit() {
        this.loading = false;
    }

    selectDocuments(event: any) {
        const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25MB
        const MAX_TOTAL_SIZE = 100 * 1024 * 1024; // 100MB
        const ALLOWED_TYPES = ["application/pdf"];

        this.files = Array.from(event);
        // Calculate the total size of the selected files (in bytes)
        const totalSize = this.files.reduce((sum, file) => sum + file.size, 0);

        // Check if the total size exceeds 25 MB
        if (totalSize > MAX_TOTAL_SIZE) {
            this.totalSizeError = true;
            this.sizeError = false;
            this.typeError = false;
        }

        for (const file of this.files) {
            // Check if any individual file size exceeds 5 MB
            if (file.size > MAX_FILE_SIZE) {
                this.sizeError = true;
                this.typeError = false;
                this.totalSizeError = false;
                continue;
            }

            // Filter out any files that are not Word, Excel, or PDF
            if (!ALLOWED_TYPES.includes(file.type)) {
                this.typeError = true;
                this.sizeError = false;
                this.totalSizeError = false;
                continue;
            }
            this.supportingDocuments.push(file);
        }

        console.log(this.extractedInvoice.get("terms_agreed").value);

        if (this.allDeleted === true) {
            if (this.extractedInvoice.get("terms_agreed").value === true) {
                this.extractedInvoice.patchValue({ terms_agreed: false });
            }
        } else {
            this.extractedInvoice.patchValue({ terms_agreed: false });
        }

        this.supportingDocsAdded = true;
    }

    /**
     * Delete file from files list
     * @param index (File index)
     */
    deleteFile(index: number) {
        this.supportingDocuments.splice(index, 1);

        if (this.supportingDocuments.length === 0) {
            if (this.extractedInvoice.get("terms_agreed").value === true) {
                this.extractedInvoice.patchValue({ terms_agreed: false });
            }

            this.canSubmitForm = false;
            this.allDeleted = true;
            this.supportingDocsAdded = false;
        }
    }

    checkSupportingDocuments() {
        if (
            this.supportingDocuments.length > 0 &&
            this.extractedInvoice.get("terms_agreed").value === false
        ) {
            this.canSubmitForm = true;
        } else {
            this.canSubmitForm = false;
        }
    }

    onDrop(event: any) {
        // Update the list order
        moveItemInArray(
            this.supportingDocuments,
            event.previousIndex,
            event.currentIndex
        );
    }

    reUploadInvoice(event: any) {
        if (event.length > 0) {
            const fileUploaded = event[0];

            //console.log(fileUploaded);

            if (fileUploaded.type !== "application/pdf") {
                this.hasError = false;
                this.fileSizeError = false;
                this.fileTypeError = true;
            } else if (fileUploaded.size > 100 * 1024 * 1024) {
                this.fileTypeError = false;
                this.hasError = false;
                this.fileSizeError = true;
            } else {
                this.fileSizeError = false;
                this.fileTypeError = false;

                if (typeof FileReader !== "undefined") {
                    let reader = new FileReader();
                    reader.onload = (e: any) => {
                        this.pdfSrc = e.target.result;
                        //console.log(this.pdfSrc);
                    };
                    let $file: any = fileUploaded;
                    reader.readAsArrayBuffer($file);
                }

                this.extractedInvoice.patchValue({
                    fileSource: fileUploaded,
                });

                this.hasError = false;
                this.isInvoiceChange = true;

                const userData = {
                    req: {
                        emailAddress: "",
                        companyCode: "",
                        purchaseOrg: "",
                        docType: "",
                        items: this.invoiceDetails.items,
                    },
                };

                this.loading = true;
                this.invoiceChanged = true;
                this.formSubmitted = true;

                const formData: any = new FormData();
                // formData.append('poNumber', this.route.snapshot.params['poNo']);
                formData.append(
                    "sellerCode",
                    localStorage.getItem("vendorCode")
                );
                formData.append(
                    "sessionId",
                    localStorage.getItem("userSession")
                );
                formData.append("invoiceType", "e-invoice");
                formData.append("req", JSON.stringify(userData.req));
                formData.append("file", this.extractedInvoice.value.fileSource);

                this.eLoaderMsg = "Verifying QR Code";

                setTimeout(() => {
                    this.eLoaderMsg = "Authenticating QR Code";
                }, 5000);
                setTimeout(() => {
                    this.eLoaderMsg = "Extracting Data";
                }, 10000);
                setTimeout(() => {
                    this.eLoaderMsg = "Validating Data";
                }, 15000);

                this.invoiceService.extractInvoice(formData).subscribe(
                    (res) => {
                        this.loading = false;
                        this.invoiceChanged = false;
                        this.formSubmitted = false;
                        this.isUpdatedData = true;
                        this.responseData = res;
                        //console.log(res);
                        if (
                            this.responseData.length !== 0 &&
                            this.responseData.status === "error"
                        ) {
                            console.log(this.responseData.message);
                        } else {
                            //console.log("Success hereresponseData");
                            this.invoiceDetails = this.responseData;
                        }
                    },
                    (error) => {
                        console.log(error.msg);
                    }
                );
            }
        }
    }

    open(content: any) {
        this.modalService.open(content, this.modalOptions).result.then(
            (result) => {
                this.closeResult = `Closed with: ${result}`;
            },
            (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
        );
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return "by pressing ESC";
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return "by clicking on a backdrop";
        } else {
            return `with: ${reason}`;
        }
    }

    onSubmit() {
        if (this.isSubmittingInvoice) {

            return;
        }

        this.isSubmittingInvoice = true;
        this.loading = true;
        this.uploadInvoice = true;
        this.saving = false;
        this.formSubmitted = true;

        const pods: any = localStorage.getItem("pods");
        const convertPods = JSON.parse(pods);

        //console.log(convertPods);

        const poItems: any = [];
        //console.log(pods);
        convertPods.forEach((p: any) => {
            if (p.grn_no !== "") {
                poItems.push({
                    poNumber: p.po_no,
                    itemNo: p.po_item_line,
                    grn: p._id,
                    grn_no: p.grn_no,
                });
            } else {
                poItems.push({
                    poNumber: p.po_no,
                    itemNo: p.po_item_line,
                    grn: "",
                    grn_no: "",
                });
            }
        });

        //console.log(poItems);

        const trimNo = this.invoiceDetails.invoice_number.replace(/\s+/g, "");

        const mapKeys = {
            file_link: this.invoiceDetails.file_link,
            SellerGstin: this.invoiceDetails.gstin,
            BuyerGstin: "",
            DocNo: trimNo,
            DocTyp: "INV",
            DocDt: this.invoiceDetails.invoice_date,
            TotInvVal: this.invoiceDetails.invoice_amount,
            ItemCnt: this.invoiceDetails.items.length,
            MainHsnCode: "",
            Irn: this.invoiceDetails.irn,
            IrnDt: "",
            invType: this.invoiceService.getInvType(),
            invoiceType: this.invoiceService.getInvoiceType(),
        };

        let companyCode = "";
        let purchaseOrg = "";
        let docType = "";

        //console.log(convertPods);
        if (convertPods[0].grn_no !== "") {
            companyCode = convertPods[0].po_company_code;
            purchaseOrg = convertPods[0].po_purchase_org;
            docType = convertPods[0].po_doc_type;

            // console.log(companyCode + " comCod");
        }

        if (convertPods[0].po_item_description !== "") {
            companyCode = this.servItems.po_company_code;
            purchaseOrg = this.servItems.po_purchase_org;
            docType = this.servItems.po_doc_type;

            // console.log(purchaseOrg + " org");
        }

        //console.log(docType + " doc");

        const userData = {
            req: {
                emailAddress: this.invoiceDetails.email_address,
                companyCode: companyCode,
                purchaseOrg: purchaseOrg,
                docType: docType,
                items: poItems,
                termsAgreed: true,
            },
        };

        if (this.isInvoiceChange === true) {
            this.invoiceFile = this.extractedInvoice.value.fileSource;
        } else {
            this.invoiceFile = this.invoiceService.getFileElement();
        }

        const fileOrder = [];
        this.supportingDocuments.forEach((file, index) => {
            const obj = {};
            obj[(index + 1).toString()] = file.name;
            fileOrder.push(obj);
        });

        const formData: any = new FormData();
        formData.append("sellerCode", localStorage.getItem("vendorCode"));
        formData.append("sessionId", localStorage.getItem("userSession"));
        formData.append("invType", this.invoiceService.getInvType());
        formData.append("fileOrder", JSON.stringify(fileOrder));
        //formData.append("invoiceType", this.invoiceService.getInvoiceType());
        formData.append("req", JSON.stringify(userData.req));
        formData.append("data", JSON.stringify(mapKeys));

        if (this.supportingDocuments.length !== 0) {
            for (let i = 0; i < this.supportingDocuments.length; i++) {
                formData.append("supportingDocs", this.supportingDocuments[i]);
            }
        } else {
            formData.append("supportingDocs", this.supportingDocuments);
        }

        // for (const value of formData.values()) {
        //     console.log(value);
        // }

        if (!this.saving) {
            this.invoiceService
                .uploadInvoiceWithoutExtration(formData)
                .subscribe(
                    (res) => {
                        this.isSubmittingInvoice = false;
                        this.responseData = res;
                        //console.log(this.responseData.status);

                        if (this.responseData.status === "error") {
                            console.log("error exist");
                            this.loading = false;
                            this.uploadInvoice = false;
                            this.hasError = true;
                            this.formSubmitted = false;
                        } else {
                            this.barcodeNo = this.responseData.barcode;
                            const data = {
                                barcode: this.barcodeNo,
                                docTyp: "INV",
                                sellerCode: localStorage.getItem("vendorCode"),
                                session: {
                                    sessionId:
                                        localStorage.getItem("userSession"),
                                },
                            };

                            // this.invoiceService
                            //     .sendInvoiceToJSW(data)
                            //     .subscribe(
                            //         (res) => {
                            //             console.log(res);
                            //         },
                            //         (error) => {
                            //             this.hasError = true;
                            //             this.responseData = {
                            //                 message:
                            //                     "We couldn't extract the invoice details due to a temporary issue.Please try again in a few moments. If the problem continues, contact support.",
                            //                 status: "error"
                            //             };
                            //         }
                            //     );
                            console.log("Success");

                            this.uploadInvoice = false;
                            this.invoiceSaved = false;
                            this.uploadSuccessful = true;

                            //console.log(this.responseData);
                        }
                    },
                    (error) => {
                        this.isSubmittingInvoice = false;
                        this.uploadInvoice = false;
                        this.uploadSuccessful = false;
                        this.invoiceSaved = false;
                        this.loading = false;
                        this.hasError = true;
                        this.responseData = {
                            message:
                                error?.msg ||
                                error?.message ||
                                "Unable to process request",
                            status: "error"
                        };
                        this.formSubmitted = false;
                        //console.log(error);
                    }
                );
        }

        this.modalService.dismissAll();
    }

    ngOnInit(): void {
        this.displayName = localStorage.getItem("displayName");
        this.invoiceDetails = this.invoiceService.getProcessedInvoice();
        localStorage.setItem("poNumber", this.invoiceDetails.poNumber);
        this.loadFile();
        this.formSubmitted = false;

        const poNo = this.route.snapshot.params["poNo"];
        const userData = {
            poNumber: poNo,
            action: "get",
            sellerCode: localStorage.getItem("vendorCode"),
            session: { sessionId: localStorage.getItem("userSession") },
        };

        this.posService.fetchPurchaseOrders(userData).subscribe(
            (res) => {
                this.responseData = res;
                //console.log(res);
                //console.log(this.responseData);
                if (this.responseData.length !== 0) {
                    //console.log(this.responseData.pos[0]);
                    this.servItems = this.responseData.pos[0];
                } else {
                    console.log(this.responseData);
                }
            },
            (error) => {
                this.hasError = true;
                this.responseData = {
                    message:
                        error?.msg ||
                        error?.message ||
                        "Unable to load purchase order. Please try again.",
                    status: "error"
                };
            }
        );
    }

    closeSuccessDialog() {
        this.loading = false;
        this.router.navigateByUrl("/invoices");
    }

    resubmitInvoice() {
        const poNo = this.route.snapshot.params["poNo"];
        this.router.navigate(["/submit-invoice", poNo]);
    }

    loadFile() {
        if (typeof FileReader !== "undefined") {
            let reader = new FileReader();
            reader.onload = (e: any) => {
                this.pdfSrc = e.target.result;
                //console.log(this.pdfSrc);
            };
            let $file: any = this.invoiceService.getFileElement();
            reader.readAsArrayBuffer($file);
        }
    }

    // onCheckboxChange(e: any) {
    //     if (e.target.checked) {
    //         this.extractedInvoice.patchValue({
    //             terms_agreed: e.target.value,
    //         });
    //     } else {
    //         this.extractedInvoice.patchValue({
    //             terms_agreed: null,
    //         });
    //     }
    // }

    viewSavedInvoices() {
        this.router.navigate(["/saved-invoices"]);
    }
}
